<template>
	<div v-loading="loading">
		<div class="box">
			
			<div class="pagemain">
				<div class="pagetablebox">
					<el-table empty-text="暫無數據" :data="data" border :header-cell-style="{background:'#FAFAFA'}">
						<el-table-column prop="date" label="時間" align="center">
							<template slot-scope="scope">
								<div class="phonecel">時間</div>
								{{scope.row.date}}
							</template>
						</el-table-column>
						<el-table-column prop="action" label="操作" align="center">
							<template slot-scope="scope">
								<div class="phonecel">操作</div>
								{{scope.row.action}}
							</template>
						</el-table-column>
						<el-table-column prop="operator" label="操作員" align="center">
							<template slot-scope="scope">
								<div class="phonecel">操作員</div>
								{{scope.row.operator}}
							</template>
						</el-table-column>
						<el-table-column prop="remarks" label="附加記錄" align="center">
							<template slot-scope="scope">
								<div class="phonecel" style="flex-shrink: 0;">附加記錄</div>
								<div v-html="scope.row.remarks"></div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			
		</div>

	</div>
</template>

<script>
	export default {
		props: ['order_id'],
		data() {
			return {
				loading:true,
				data:[
				],
			};
		},
		methods: {
			getdata() {
			
				this.post('/api/order/order_records', {
					order_id: this.order_id
				}).then((res) => {
					// console.log(res);	
					this.data = res;
					this.loading = false;
				}).catch((err) => {
					console.log(err)
				})
			}
		},
		created() {
			this.getdata();
		}
	};
</script>

<style scoped>
	
</style>
